export default "__VITE_ASSET__yx8c5uzp__"